export default "__VITE_ASSET__CgqxJeLN__"